import axios from './axios';
import config from '../../helpers/config';

export default designId => (
  axios.get(`${config.designBuilderLoadDesignPath}/${designId}/getItemDataForAnalytics`)
);
